import { render, staticRenderFns } from "./ExpandableDescription.vue?vue&type=template&id=3c3d42bc"
import script from "./ExpandableDescription.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExpandableDescription.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ExpandableDescription.vue?vue&type=style&index=0&id=3c3d42bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports